import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class GeneratePassword extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addListeners();
    }

    addListeners() {
        this.addEventListener('click', e => {
            e.preventDefault();

            var href = this.dataset.href;

            var requestor = new Requestor();

            requestor.sendRequest(href,'GET',null,
                data => {
                    let passKey = document.getElementById('passKey');

                    passKey.innerHTML = data;
                    passKey.style.display = "block";
                }
            );
        });
    }
}

